<template>
  <div id="four_factors_on_off" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2" v-if="players.length > 0">
        <player-select v-model="player_selected" :options="players" label="Player"></player-select>
      </div>

    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Charts</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div id="chart_container">
      <p v-if="minutes_on != undefined">Minutes On: {{ minutes_on }}</p>
      <p v-if="minutes_off != undefined">Minutes Off: {{ minutes_off }}</p>
      <h2 v-if="minutes_on != undefined">Team</h2>
      <svg id="offense" width="600" height="400"></svg>
      <h2 v-if="minutes_on != undefined">Opponent</h2>
      <svg id="defense" width="600" height="400"></svg>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PlayerSelect from './mixins/PlayerSelect.vue'
import { season, seasonType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'FourFactorOnOff',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, PlayerSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      players: [],
      player_selected: undefined,
      team_dropdown: {},
      team_selected: undefined,
      offense_results: undefined,
      defense_results: undefined,
      minutes_on: undefined,
      minutes_off: undefined,
      show_error_message: false,
      api_endpoint: 'get-four-factor-on-off/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      this.table_data = []
      this.seasons_selected = []
      this.$router.push({name: 'four_factors_on_off', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    checkIfStatsShouldBeLoaded (response) {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.team_selected) {
        this.changePlayers()
        this.getStats()
      }
    },
    loadData () {
      this.offense_results = undefined
      this.defense_results = undefined
      this.minutes_on = undefined
      this.minutes_off = undefined
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.query.PlayerId) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changePlayers () {
      this.getPlayersForTeam([this.setPlayerSelected])
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }
      if (this.player_selected) {
        params[this.$playerIdParam] = this.player_selected.playerId
      }

      this.$router.push({name: 'four_factors_on_off', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.offense_results = undefined
      this.defense_results = undefined
      this.minutes_on = undefined
      this.minutes_off = undefined
      d3.selectAll('svg > *').remove()
      var params = this.$route.query

      if (params.Season && params.SeasonType && params.TeamId && params.PlayerId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.offense_results = response.data.offense_results
              this.defense_results = response.data.defense_results
              this.minutes_on = response.data.minutes_on
              this.minutes_off = response.data.minutes_off
              this.addChart(this.offense_results, 'offense')
              this.addChart(this.defense_results, 'defense')
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart (data, divId) {
      var svg = d3.select('svg#' + divId)
      var margin = {top: 20, right: 20, bottom: 30, left: 40}
      var width = +svg.attr('width') - margin.left - margin.right
      var height = +svg.attr('height') - margin.top - margin.bottom
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var tooltip = d3.select('div#chart_container').append('div').attr('class', 'four-factor-tooltip')

      var x0 = d3.scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.1)

      var x1 = d3.scaleBand()
        .padding(0.05)

      var y = d3.scaleLinear()
        .rangeRound([height, 0])

      var axisClasses = d3.scaleOrdinal()
        .range(['four-factors-off', 'four-factors-on'])

      var keys = ['On', 'Off']

      x0.domain(data.map(function (d) { return d.stat }))
      x1.domain(keys).rangeRound([0, x0.bandwidth()])
      y.domain([0, d3.max(data, function (d) { return d3.max(keys, function (key) { return d[key] }) })]).nice()

      var classMap = {On: 'four-factors-on', Off: 'four-factors-off'}

      g.append('g')
        .selectAll('g')
        .data(data)
        .enter().append('g')
        .attr('transform', function (d) { return 'translate(' + x0(d.stat) + ',0)' })
        .selectAll('rect')
        .data(function (d) { return keys.map(function (key) { return {key: key, value: d[key]} }) })
        .enter().append('rect')
        .attr('x', function (d) { return x1(d.key) })
        .attr('y', function (d) { return y(d.value) })
        .attr('width', x1.bandwidth())
        .attr('height', function (d) { return height - y(d.value) })
        .attr('class', function (d) { return classMap[d.key] })
        .on('mousemove', function (d) {
          tooltip
            .style('left', d3.event.pageX - 50 + 'px')
            .style('top', d3.event.pageY - 70 + 'px')
            .style('display', 'inline-block')
            .html((d.key) + ': ' + (Math.round(d.value * 1000) / 1000))
        })
        .on('mouseout', function (d) { tooltip.style('display', 'none') })

      g.append('g')
        .attr('class', 'axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(x0))

      g.append('g')
        .attr('class', 'axis')
        .call(d3.axisLeft(y).ticks(null, '.2f'))
        .append('text')
        .attr('x', 2)
        .attr('y', y(y.ticks().pop()) + 0.5)
        .attr('dy', '0.32em')
        .attr('fill', '#000')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start')

      var legend = g.append('g')
        .attr('font-family', 'sans-serif')
        .attr('font-size', 10)
        .attr('text-anchor', 'end')
        .selectAll('g')
        .data(keys.slice().reverse())
        .enter().append('g')
        .attr('transform', function (d, i) { return 'translate(0,' + i * 20 + ')' })

      legend.append('rect')
        .attr('x', width - 19)
        .attr('width', 19)
        .attr('height', 19)
        .attr('class', axisClasses)

      legend.append('text')
        .attr('x', width - 24)
        .attr('y', 9.5)
        .attr('dy', '0.32em')
        .text(function (d) { return d })
    }
  }
}
</script>

<style>
.four-factor-tooltip {
  position: absolute;
  display: none;
  height: auto;
  background: none repeat scroll 0 0 #ffffff;
  border: 1px solid black;
  text-anchor: middle;
  padding: 5px;
}

svg rect.four-factors-off {
  fill: red;
}

svg rect.four-factors-on {
  fill: green;
}

.axis {
  font: 10px sans-serif;
}

.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
  stroke-width: .5;
}

</style>



// WEBPACK FOOTER //
// src/components/FourFactorsOnOffCharts.vue